export default function EstimateSeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Fermi estimation — the most useful math skill no one teaches
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        How many piano tuners are there in Chicago? How many breaths do you
        take in a year? How many grains of sand are on Earth? These are
        Fermi questions — named for physicist Enrico Fermi, who famously
        estimated the yield of the Trinity nuclear test by dropping paper
        scraps as the shockwave passed and watching how far they flew.
        The answer was within a factor of two of the true 21 kilotons.
        Fermi estimation is the skill of getting any quantity to within
        an order of magnitude using nothing but plausible building blocks
        — and it's one of the most useful skills you can develop in
        science, engineering, or just being a good citizen of the world.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        How the game works
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Each puzzle is a Fermi chain — a sequence of multiplied estimates
        that combine to a final answer. You pick a value for each factor
        within an order of magnitude (10⁻¹, 10⁰, 10¹, etc.), and the chain
        multiplies them together. If the final product is within 2× of the
        true answer, you win. The corpus is verified: every chain in the
        game multiplies to within 2× of its stated answer when each factor
        is chosen at its true order of magnitude, so a correct estimation
        chain always wins.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        The two big lessons
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        First — errors cancel. If one factor is too high by 3× and another
        is too low by 3×, the product is correct. This is why Fermi
        estimates work even though each individual factor might be wrong.
        Second — small errors compound, but slowly. An estimate with five
        factors each off by 2× ends up off by about 5× total, not 32×.
        Together these mean that anyone willing to break a question into
        steps and estimate each step can get useful answers to questions
        that look impossible. Sagan called this "the candle in the dark."
      </p>
    </>
  );
}
